import { create } from 'zustand';

/**
 * Connectivity and sync state for the indicator in the top bar.
 *   reachable  the API answered recently (navigator.onLine alone isn't enough: Wi-Fi without internet)
 *   permit     this device's offline billing permit: { enabled, reason, exp, remainingMs }
 */
export const useOffline = create((set) => ({
  reachable: true,
  pending: 0,
  failed: 0,
  syncing: false,
  lastSyncAt: null,
  permit: null,
  set: (patch) => set(patch),
}));

export const isNetworkError = (err) => err?.code === 'NETWORK_ERROR' || err?.status === 0;
